import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { TimezoneModule } from '../timezone/timezone.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { DeliveryStatusTrackingStatusComponent } from './delivery-status-tracking-status.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DeliveryStatusTrackingStatusComponent],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, TimezoneModule, TooltipModule, SvgIconModule],
  exports: [DeliveryStatusTrackingStatusComponent],
})
export class DeliveryStatusTrackingStatusModule {}
